import { BbQueueManager } from '@Components/BigBrowse/bb2/BbQueueManager';
import { getDepartmentsVM } from '@Map/shared/shopFloorLayout';
// @ts-expect-error
import type { ShopFloorDM } from '@Model/FloorModels';
import type { MapShopLayoutDepartmentVM } from '@Model/MapModelsView';
import type { TransientClass } from '@Utils/useClassStore';
import { inject, injectable } from 'inversify';
import { computed } from 'mobx';
import { createContext, useContext } from 'react';

import container from '~ioc/ioc';
import type { FloorStore } from '~stores/floor';

@injectable()
export class MiniShopFloorPresenter implements TransientClass {
  @inject(BbQueueManager) private _bbQueueManager!: BbQueueManager;
  private _floorStore?: FloorStore;

  init = (floorStore: FloorStore) => {
    this._floorStore = floorStore;
  };

  @computed get departmentsVM(): MapShopLayoutDepartmentVM[] {
    const content = this._floorStore?.content.value;

    if (!content) {
      return [];
    }

    // @ts-expect-error
    return getDepartmentsVM(content.data as ShopFloorDM);
  }

  @computed get title(): string | undefined {
    return this._floorStore?.data?.title;
  }

  @computed get activeDepartmentId() {
    return this._bbQueueManager.root?.activeDepartment?.id;
  }

  destroy = () => {
    /* do nothing */
  };
}

container.bind(MiniShopFloorPresenter).toSelf().inTransientScope();

export const getMiniShopFloorPresenter = (floorStore: FloorStore) => {
  const presenter = container.get(MiniShopFloorPresenter);
  presenter.init(floorStore);

  return presenter;
};

export const MiniShopFloorPresenterContext =
  createContext<MiniShopFloorPresenter | null>(null);

export const useMiniShopFloorPresenter = () => {
  const presenter = useContext(MiniShopFloorPresenterContext);

  if (presenter === null) {
    throw new Error('MiniShopFloor Context was not initialized');
  }

  return presenter;
};
